import Location from './Location';

import WharenuiGraphics from './WharenuiGraphics';
import WharenuiQuiz from './QuizMessaging';

export default class Wharenui extends Location {
    constructor() {
        super('wharenui');
        this.Graphics = WharenuiGraphics;
        this.Quiz = WharenuiQuiz
    }
    playBackgroundSound() {
        this.scene.get('sounds').setBackgroundSound('wharenui', 0.05);
    }



    //Unique guide settings for Wharenui
    guideSettings() {
        return ({
            x: 120,
            y: 300,
            //When the guide is ready showSpeech bubble
            callback: this.showSpeech
        });
    }

    maramaSpeaker() {

        return ({
            xmlLoader: this.scene.get('xmlLoader'),
            isBack: true
        });
    }





}